export default "__VITE_ASSET__D0MDgXC0__"